import { useFormContext } from "react-hook-form";

import { NoAgentSelected } from "src/agentNode/components/agentSelectionModal/NoAgentSelected";
import { SelectedAgentDisplay } from "src/agentNode/components/agentSelectionModal/SelectedAgentDisplay";
import { useAgent, useAgentVersion } from "src/agents/queries/management";
import { Card } from "src/base-components/Card";
import { SkeletonPlaceholder } from "src/base-components/SkeletonPlaceholder";
import { AgentNodeData } from "src/constants/NodeDataTypes";

type Props = {
  immutable: boolean;
  onRequestOpenModal: () => void;
};

export const AgentSelectionEditor: React.FC<Props> = ({
  immutable,
  onRequestOpenModal,
}) => {
  const { watch } = useFormContext<AgentNodeData>();

  const agentId = watch("agent_id");
  const versionId = watch("agent_version_id");

  const agentQuery = useAgent(agentId ?? "");
  const versionQuery = useAgentVersion(agentId ?? "", versionId ?? "");

  const noAgentSelected = !agentId || !versionId;

  if (noAgentSelected) {
    return (
      <NoAgentSelected
        handleSelectAgent={onRequestOpenModal}
        immutable={immutable}
        type="agent-selection"
      />
    );
  }

  if (agentQuery.isLoading || versionQuery.isLoading) {
    return (
      <Card>
        <SkeletonPlaceholder height="h-5" width="w-48" />
      </Card>
    );
  }

  if (!agentQuery.data || !versionQuery.data) {
    return (
      <NoAgentSelected
        handleSelectAgent={onRequestOpenModal}
        immutable={immutable}
        type="agent-selection"
      />
    );
  }

  return (
    <SelectedAgentDisplay
      agent={agentQuery.data}
      handleChangeAgent={onRequestOpenModal}
      immutable={immutable}
      version={versionQuery.data}
    />
  );
};
